import { render, staticRenderFns } from "./VBlock.vue?vue&type=template&id=049eafee&scoped=true"
import script from "./VBlock.vue?vue&type=script&lang=js"
export * from "./VBlock.vue?vue&type=script&lang=js"
import style0 from "./VBlock.vue?vue&type=style&index=0&id=049eafee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049eafee",
  null
  
)

export default component.exports